import { useRef } from 'react';

let globalCounter = 1;

export function useMountSuffix(): string {
  const suffixRef = useRef<string>(
    `${Date.now().toString(36)}-${(++globalCounter).toString(36)}-${Math.random().toString(36).slice(2, 8)}`
  );
  console.log('[useMountSuffix] generated suffix:', suffixRef.current);
  return suffixRef.current;
}
